import styled from "styled-components";
import { colors } from "../../styles/figmaColors";
import { HelpFilled } from "../materialUi/materialUi";
import { TooltipHover } from "./TooltipHover";

type DirectionType = "top" | "right" | "bottom" | "left";

interface TooltipDSProps {
  id: string;
  place: DirectionType;
  title?: string;
  content: string;
}

export const TooltipDS = (props: TooltipDSProps) => {
  return (
    <>
      <StyledIcon>
        <HelpFilled data-tooltip-id={props.id} />
      </StyledIcon>
      <TooltipHover id={props.id} place={props.place} content={props.content} />
    </>
  );
};

const StyledIcon = styled.div`
  display: flex;
  & svg {
    fill: ${colors["colors/accent/500"]};
    outline: none;
  }
`;
